module.exports = __webpack_public_path__ + "static/QinGaoMock-90915a2a6f9888e09b5aa0232585bdc5.png";